import React from "react";
import PropTypes from "prop-types";

import { Route, Redirect, useLocation } from "react-router-dom";

const PrivateRoute = ({
  component: Component,
  auth,
  isMobile,
  isMenuOpen,
  innerWidth,
  hideOnMobile,
  minRole,

  ...rest
}) => {
  const location = useLocation();

  if (location.pathname === "/app/bulk-migration") {
    const allowedToViewBulkUpdate = auth?.roles?.some(
      (role) => role.name === "Billing Admin" || role.name === "Admin"
    );

    if (!allowedToViewBulkUpdate) {
      return <Redirect to="/app/dashboard" />;
    }
  }

  if ((isMobile && hideOnMobile) || minRole > auth.maxRole) {
    return (
      <Redirect
        to={location.pathname === "/app" ? "/app/dashboard" : location.pathname}
      />
    );
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        auth.isAuth ? (
          <Component
            {...props}
            auth={auth}
            isMobile={isMobile}
            isMenuOpen={isMenuOpen}
            innerWidth={innerWidth}
            pathname={window.location.pathname}
          />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  auth: PropTypes.object,
  isMobile: PropTypes.bool,
  isMenuOpen: PropTypes.bool,
  innerWidth: PropTypes.number,
  hideOnMobile: PropTypes.bool,
  minRole: PropTypes.number
};

PrivateRoute.defaultProps = {
  hideOnMobile: false,
  minRole: 1000
};

export default PrivateRoute;
